/**
 * Victory Homes Real Estate — Company Details
 * Centralized constants for use across all components.
 * Used in: Footer, Navbar, Contact Page, etc.
 */

export const COMPANY = {
  name: 'Victory Homes Real Estate',
  shortName: 'Victory Homes',
  email: 'info@victoryhomesre.com',
  phone: '+971 4 252 6128',
  whatsapp: '+971 50 376 8662',
  location: 'Office 1822, Burjuman Business Center, Burjuman Center, Dubai, United Arab Emirates',
  locationShort: 'Burjuman Business Center, Dubai, UAE',
  copyright: `${new Date().getFullYear()} © Victory Homes Real Estate. All rights reserved.`,
}

export const SOCIALS = {
  facebook: 'https://www.facebook.com/VictoryHomesRE/',
  instagram: 'https://www.instagram.com/victoryhomesrealestate/',
  linkedin: 'https://www.linkedin.com/in/victory-homes/',
  x: 'https://x.com/VictoryHomes_RE',
  youtube: 'https://www.youtube.com/@victoryhomesrealestate6276',
  tiktok: 'https://www.tiktok.com/@victoryhomesrealestate?lang=en-GB',
}
